import React, { useContext } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import DrawerMenu from '../menu/DrawerMenu';
import SideMenu from '../menu/SideMenu';
import Loader from '../loader/Loader';
import ProfileOptions from '../menu/ProfileOptions';
import GeneralContext from '../../context/GeneralContext/GeneralContext';

const { Header, Content } = Layout;

const InternalLayout = () => {
  const {
    mobile_mode,
  } = useContext(GeneralContext);

  return (
    <Layout style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'row' }}>
      <Loader />

      {mobile_mode ? <DrawerMenu /> : <SideMenu />}

      <Layout className="site-layout" style={{ background: "white", display: 'flex', flexDirection: 'column', height: '100vh', width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
        <Header style={{ 
          background: 'white', 
          padding: 0, 
          borderBottom: '2px solid #1b3663', 
          boxShadow: '0px -15px 39px #1b3663' 
        }}>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            flex: 1, 
            justifyContent: 'flex-end', 
            alignItems: 'center', 
            height: '100%', 
            gap: 15,
            paddingLeft: mobile_mode ? 60 : 0 
          }}>
            <ProfileOptions />
          </div>
        </Header>

        <div
          style={
            mobile_mode ? {
              width: '100vw',
              height: '100vh',
              flex: 1,
              margin: '16px 0px',
              overflow: 'scroll'
            } : {
              width: '100%',
              maxWidth: '100%',
              height: 'unset',
              flex: 1,
              padding: "0px !important",
              overflow: 'auto',
              overflowX: 'hidden'
            }
          }
        >
          <Content
            className="site-layout-background"
            style={{
              flex: 1,
              height: '100%',
              padding: mobile_mode ? 8 : 16,
              width: mobile_mode ? '100%' : '100%',
              maxWidth: '100%',
              display: 'flex',
              flexDirection: 'column',
              overflowX: 'hidden'
            }}
          >
            <Outlet />
          </Content>
        </div>
      </Layout>
    </Layout>
  );
};

export default InternalLayout;



